import React from "react";
import "./TextContent.scss";

const TextContent = ({ data, userAgent }) => {
return (
    <div className="text-content">
      {data?.main_title && <h1>{data?.main_title}</h1>}
      {data?.paragraph && <p>{data?.paragraph}</p>}
    </div>
  );
};

export default TextContent;
